interface AdvisorName {
  firstName?: string | null;
  lastName?: string | null;
}

export const formatAdvisorName = (advisor: AdvisorName) => {
  const firstName = advisor.firstName?.trim();
  const lastName = advisor.lastName?.trim();

  if (!firstName && !lastName) return "Unknown";
  if (!lastName) return firstName || "Unknown";
  if (!firstName) return lastName;

  return `${lastName}, ${firstName}`;
};
